/****************************************************
 * Module Name:  WatchlistProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:         info@pansuriyaimpex.com
 * 
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class WatchlistProxy {

    static AddToWatchlist = (watchlistStone, callback) => {
        restAPICall(
            Constants.MANAGER_URL + '/watchlist',
            'post',
            Constants.userToken,
            undefined,
            JSON.stringify(watchlistStone),
            'application/json',
            0)
            .then(response => callback(response))
            .catch((e) => {
                callback(undefined);
            });
    }

    static UpdateWatchlistRemarks = (watchlistStone, callback) => {
        restAPICall(
            Constants.MANAGER_URL + '/watchlist',
            'put',
            Constants.userToken,
            undefined,
            JSON.stringify(watchlistStone),
            'application/json',
            0)
            .then(response => callback(response))
            .catch((e) => {
                callback(undefined);
            });
    }

    static ShowWatchlist = (userid, isNatural, callback) => {
        let params = { isNatural: isNatural };
        restAPICall(
            Constants.MANAGER_URL + `/watchlist/detail/${userid}/refresh`,
            'get',
            Constants.userToken,
            params,
            undefined,
            undefined,
            0)
            .then(response => callback(response))
            .catch((e) => callback(undefined));
    }

    static RemoveFromWatchlist = (deletedWatchlist, callback) => {
        restAPICall(Constants.MANAGER_URL + '/watchlist',
            'delete',
            Constants.userToken,
            undefined,
            JSON.stringify(deletedWatchlist),
            'application/json',
            0)
            .then(response => callback(response))
            .catch((e) => callback(undefined));
    }
}